export default "__VITE_ASSET__DXto7z69__"